;(function($) {

    'use strict';

    var pluginName = 'ship-methods';

    var defaults = {
        // child input
        childInput: '[name="ship_method"]',
        // trigger change on init
        triggerOnInit: false
    };

    /**
     * ShippingMethods
     * @constructor
     * @param {Object} element
     * @param {Object} options (Optional)
     */
    function ShippingMethods(element, options) {
        this.$element = $(element);
        this.opts = $.extend({}, defaults, options);

        this.$selected = null;

        this._init();
    }

    /**
     * Init
     * @private
     */
    ShippingMethods.prototype._init = function() {
        this.$element.on('change.'+pluginName, this.opts.childInput, $.proxy(this._change, this));

        if(this.opts.triggerOnInit === true) {
            if(this.$element.find(this.opts.childInput+':checked').length > 0) {
                this.$element.find(this.opts.childInput+':checked').trigger('change');
            }
        }
    };

    /**
     * Change
     * @private
     */
    ShippingMethods.prototype._change = function(event) {
        this.$selected = $(event.target);
        this.$element
            .attr('data-prev-selected', this.$selected.val())
            .data('prev-selected', this.$selected.val());

        $(window).trigger('change.shipmethod', [this.$selected, event]);
    }

    /**
     * Destroy instance
     * @public
     */
    ShippingMethods.prototype.destroy = function() {
        delete this.$selected;

        // element
        this.$element.off('change.'+pluginName);
        this.$element.removeData(pluginName);
        this.$element = null;
    };


    /**
     * jQuery plugin wrapper
     */
    $.fn.shippingMethods = function(options) {
        return this.each(function(){
            var plugin = $.data(this, pluginName);

            if(!plugin) {
                $.data(this, pluginName, new ShippingMethods(this, options));
            }
        });
    };

})(jQuery);